import React from 'react';
import { AlertTriangle } from 'lucide-react';

const Terms = () => {
  return (
    <div className="pt-20 bg-gray-900">
      {/* Critical Alert Banner */}
      <div className="bg-red-800 text-white py-3 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center text-center text-sm sm:text-base">
            <AlertTriangle className="h-4 w-4 mr-2 flex-shrink-0" />
            <p className="font-semibold">
              CRITICAL: Fewer than 10 vaquitas remain. Extinction expected within months without immediate action.
            </p>
          </div>
        </div>
      </div>

      <div className="min-h-screen bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-4xl font-bold text-white mb-8">Terms of Use</h1>
          
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">About Fight for Vaquita</h2>
              <p>
                Fight for Vaquita is a student-run, nonprofit conservation initiative dedicated to raising awareness about the critically endangered vaquita porpoise. By using this website, you agree to these terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Educational Use</h2>
              <p className="mb-4">
                Our content is provided for educational and awareness purposes. You may use our materials for:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Educational presentations and research</li>
                <li>Non-commercial awareness campaigns</li>
                <li>Academic and scientific purposes</li>
                <li>Personal learning and sharing</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Attribution Requirements</h2>
              <p className="mb-4">When using our content, please:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Credit "Fight for Vaquita" as the source</li>
                <li>Include a link back to our website when possible</li>
                <li>Do not alter factual or scientific information</li>
                <li>Respect the educational mission of our content</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Prohibited Uses</h2>
              <p className="mb-4">You may not use our content for:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Commercial purposes without permission</li>
                <li>Misrepresenting facts about vaquita conservation</li>
                <li>Activities that could harm conservation efforts</li>
                <li>Unlawful or harmful activities</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">External Links</h2>
              <p>
                Our website links to external resources including research databases, conservation organizations, and educational institutions. We are not responsible for the content or availability of external sites.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Accuracy</h2>
              <p>
                We strive to provide accurate, up-to-date information about vaquita conservation. However, the situation is rapidly evolving, and we recommend consulting multiple scientific sources for the most current data.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Student Organization</h2>
              <p>
                Fight for Vaquita is operated by students passionate about marine conservation. While we aim for accuracy and professionalism, we are a learning organization committed to continuous improvement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Contact</h2>
              <p>
                Questions about these terms? Contact us at{' '}
                <a href="mailto:contact@fightforvaquita.org" className="text-blue-400 hover:text-blue-300">
                  contact@fightforvaquita.org
                </a>
              </p>
            </section>

            <section>
              <p className="text-sm text-gray-400">
                Last updated: January 2025
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;